import React from 'react';
import cx from 'classnames';

interface Props {
  children: any;
  className?: string;
}

export default (props: Props) => (
  <div
    className={cx('u-padding-A-s', props.className)}
    style={{
      border: '1px solid #1A9966',
      borderRadius: 8
    }}
  >
    {props.children}
  </div>
);
